import React, { useContext, useState } from 'react';
import { GlobalContext } from 'providers/GlobalProvider';
import AIEvalProduct from './AIEvalProduct';
import CreateTicketWizard from 'components/Wizard/CreateTicketWizard';
import { Modal } from '@mui/material';
import { LoadingFeedback } from 'components/Common/LoadingModal';
import WorkflowSingleScreeningResults from '../tables/WorkflowSingleScreeningResults';
import WorkflowMulti from '../tables/WorkflowMulti';
import ProductScreeningResultsTable from '../tables/commodityTable/ProductScreeningResultsTable';
import CustomsFlagsSummary from '../CustomsFlagsSummary';

interface ISearchProps {
  inputs: any;
  handleSubmit: any;
  results: any;
  page: number;
  setPage: any;
  type: string;
  setShowFullRecord: any;
  cyberHeaders: string[];
  getCSVResults?: any;
  handleMultiPageChange?: any;
  aiSums?: any;
  createTicket?: any;
  saving?: boolean;
  setFrequency?: any;
  frequency?: string;
  shareEmail: string[];
  setShareEmail?: any;
  ticketNameOpen: boolean;
  setTicketNameOpen?: any;
  handleOpenModal?: any;
  aiLoading?: boolean;
  newTicketName: string;
  setNewTicketName: any;
  isExpands?: boolean;
  isSelected?: boolean;
  resultsOnly?: boolean;
  autoOpenFirstLens?: boolean;
  defaultResultLevel?: 2 | 3;
}

const SearchWorkflow: React.FC<ISearchProps> = ({
  setShowFullRecord,
  type,
  setPage,
  page,
  inputs,
  handleSubmit,
  results,
  cyberHeaders,
  getCSVResults,
  handleMultiPageChange,
  aiSums,
  createTicket,
  saving,
  setFrequency,
  frequency,
  shareEmail,
  setShareEmail,
  ticketNameOpen,
  setTicketNameOpen,
  handleOpenModal,
  aiLoading,
  newTicketName,
  setNewTicketName,
  isExpands,
  isSelected,
  resultsOnly,
  autoOpenFirstLens,
  defaultResultLevel,
}) => {
  const [isExpand, setIsExpand] = useState(isExpands);
  const [isExpandProd, setIsExpandProd] = useState(true);
  const [isExpandSecNotes, setIsExpandSecNotes] = useState(true);

  const { cur_user, ticketDraft } = useContext(GlobalContext);
  const shouldUseLensTable = defaultResultLevel !== undefined;
  const shouldUseProductResultsTable = type === 'Products';

  const handleTicketNameClose = () => {
    setTicketNameOpen(false);
    setNewTicketName('');
  };

  const renderScreeningResults = () => (
    <>
      {!results.isLoading &&
        results.data.length === 1 &&
        !shouldUseLensTable &&
        (type === 'Cyber' ||
          !results.data[0]?.result?.body?.hits?.hits[0]?.matched_queries) && (
          <WorkflowSingleScreeningResults
            setShowFullRecord={setShowFullRecord}
            type={type}
            handleSubmit={handleSubmit}
            setPage={setPage}
            page={page}
            results={results}
            cyberHeaders={cyberHeaders}
            getCSVResults={getCSVResults}
            setTicketNameOpen={setTicketNameOpen}
            inputs={inputs}
            handleOpenModal={handleOpenModal}
          />
        )}

      {!results.isLoading &&
        results.data.length > 0 &&
        shouldUseProductResultsTable && (
          <div className='entity-screening-results-shell product-screening-results-shell'>
            <ProductScreeningResultsTable
              handleSubmit={handleSubmit}
              setPage={setPage}
              page={page}
              results={results}
            />
          </div>
        )}

      {!results.isLoading &&
        results.data.length > 0 &&
        !shouldUseProductResultsTable &&
        (shouldUseLensTable ||
          results.data[0]?.result?.body?.hits?.hits[0]?.matched_queries
            ?.length > 0) &&
        !(type === 'Cyber') && (
          <WorkflowMulti
            setShowFullRecord={setShowFullRecord}
            type={type}
            handleSubmit={handleSubmit}
            inputs={inputs}
            setPage={setPage}
            page={page}
            results={results}
            cyberHeaders={cyberHeaders}
            handleMultiPageChange={handleMultiPageChange}
            createTicket={createTicket}
            saving={saving}
            shareEmail={shareEmail}
            setShareEmail={setShareEmail}
            setFrequency={setFrequency}
            frequency={frequency}
            ticketNameOpen={ticketNameOpen}
            setTicketNameOpen={setTicketNameOpen}
            newTicketName={newTicketName}
            setNewTicketName={setNewTicketName}
            handleOpenModal={handleOpenModal}
            autoOpenFirstLens={autoOpenFirstLens}
            defaultResultLevel={defaultResultLevel}
          />
        )}
    </>
  );

  const renderTicketModal = () => (
    <Modal open={ticketNameOpen} onClose={handleTicketNameClose}>
      <CreateTicketWizard
        cur_user={cur_user}
        ticketType={'screening'}
        setFrequency={setFrequency}
        frequency={frequency}
        handleSaveTicket={createTicket}
        newTicketName={newTicketName || ticketDraft.ticketName}
        setNewTicketName={setNewTicketName}
        shareEmail={shareEmail}
        setShareEmail={setShareEmail}
        savingTicket={saving || false}
      />
    </Modal>
  );

  if (resultsOnly) {
    return (
      <>
        {results.isLoading ? (
          <LoadingFeedback size='small' />
        ) : results.data.length > 0 ? (
          renderScreeningResults()
        ) : (
          <p className='classification-status'>
            No screening results available.
          </p>
        )}
        {renderTicketModal()}
      </>
    );
  }

  return (
    <>
      <div
        className={`classify-res-comp ${isSelected ? 'selected' : ''}`}
        style={{ width: '100%', minWidth: '95%' }}
      >
        <div className='classify-res-comp-header'>
          <div className='classify-res-comp-header-left-icon'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='16'
              height='16'
              viewBox='0 0 16 16'
              fill='none'
            >
              <path
                d='M6.00008 7.66666L7.33341 9L10.3334 6M13.3334 8C13.3334 11.2723 9.76411 13.6523 8.46541 14.4099C8.31781 14.496 8.24402 14.5391 8.13987 14.5614C8.05904 14.5787 7.94112 14.5787 7.86029 14.5614C7.75615 14.5391 7.68235 14.496 7.53475 14.4099C6.23606 13.6523 2.66675 11.2723 2.66675 8V4.81173C2.66675 4.27872 2.66675 4.01222 2.75392 3.78313C2.83093 3.58076 2.95607 3.40018 3.11852 3.25702C3.30241 3.09495 3.55195 3.00138 4.05102 2.81423L7.62555 1.47378C7.76415 1.4218 7.83345 1.39582 7.90474 1.38552C7.96797 1.37638 8.03219 1.37638 8.09543 1.38552C8.16672 1.39582 8.23602 1.4218 8.37461 1.47378L11.9491 2.81423C12.4482 3.00138 12.6978 3.09495 12.8816 3.25702C13.0441 3.40018 13.1692 3.58076 13.2462 3.78313C13.3334 4.01222 13.3334 4.27872 13.3334 4.81173V8Z'
                stroke='var(--text-classify)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </div>
          <div className='classify-res-comp-header-text'>
            Customs Flags
          </div>
          <div
            className='classify-res-comp-header-left-icon'
            style={{ paddingTop: '2px' }}
          >
            {!results.isLoading && results.data.length === 1 && !isExpand ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M13.3327 4L5.99935 11.3333L2.66602 8'
                  stroke='#17B26A'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            ) : !results.isLoading && results.data.length === 1 && isExpand ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M13.3327 4L5.99935 11.3333L2.66602 8'
                  stroke='#17B26A'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            ) : (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <g clipPath='url(#clip0_1_34184)'>
                  <path
                    d='M8.00016 3.99992V7.99992L10.6668 9.33325M14.6668 7.99992C14.6668 11.6818 11.6821 14.6666 8.00016 14.6666C4.31826 14.6666 1.3335 11.6818 1.3335 7.99992C1.3335 4.31802 4.31826 1.33325 8.00016 1.33325C11.6821 1.33325 14.6668 4.31802 14.6668 7.99992Z'
                    stroke='#F79009'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                  />
                </g>
                <defs>
                  <clipPath id='clip0_1_34184'>
                    <rect width='16' height='16' fill='white' />
                  </clipPath>
                </defs>
              </svg>
            )}
          </div>
          <div
            className='classify-res-comp-header-left-icon'
            style={{ paddingTop: '2px' }}
          >
            {!isExpand ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                onClick={() => setIsExpand(!isExpand)}
              >
                <path
                  d='M10 12L6 8L10 4'
                  stroke='var(--text-classify)'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            ) : (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                onClick={() => setIsExpand(!isExpand)}
              >
                <path
                  d='M4 6L8 10L12 6'
                  stroke='var(--text-classify)'
                  strokeWidth='1.5'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            )}
          </div>
        </div>
        {!isExpand && !results.isLoading ? (
          results.data.length === 1 ? (
            <CustomsFlagsSummary hsCode={inputs.hsCode} aiSums={aiSums} />
          ) : (
            <p className='classification-status'>{'Awaiting information...'}</p>
          )
        ) : results.isLoading ? (
          <LoadingFeedback size='small' />
        ) : (
          results.data.length > 0 && (
            <>
              <CustomsFlagsSummary hsCode={inputs.hsCode} aiSums={aiSums} />

              <div className='classify-res-comp-sec-col'>
                <div className='classify-res-comp-sec'>
                  <div className='classify-res-comp-sec-left'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='10'
                      height='15'
                      viewBox='0 0 10 15'
                      fill='none'
                    >
                      <path
                        d='M0.75 10.0833C0.75 11.5561 1.94391 12.75 3.41667 12.75H6.08333C7.55609 12.75 8.75 11.5561 8.75 10.0833C8.75 8.61057 7.55609 7.41667 6.08333 7.41667H3.41667C1.94391 7.41667 0.75 6.22276 0.75 4.75C0.75 3.27724 1.94391 2.08333 3.41667 2.08333H6.08333C7.55609 2.08333 8.75 3.27724 8.75 4.75M4.75 0.75V14.0833'
                        stroke='var(--text-classify)'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </div>
                  <div className='classify-res-comp-sec-txt'>
                    Important Notes
                  </div>
                  <div className='classify-res-comp-sec-left'>
                    {!isExpandProd ? (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        onClick={() => setIsExpandProd(!isExpandProd)}
                      >
                        <path
                          d='M10 12L6 8L10 4'
                          stroke='var(--text-classify)'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        onClick={() => setIsExpandProd(!isExpandProd)}
                      >
                        <path
                          d='M4 6L8 10L12 6'
                          stroke='var(--text-classify)'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {isExpandProd && !results.isLoading && type === 'Products' && (
                  <AIEvalProduct aiSums={aiSums} aiLoading={aiLoading} />
                )}
              </div>

              <div className='export-divider' style={{ display: 'flex' }} />

              <div className='classify-res-comp-sec-col'>
                <div className='classify-res-comp-sec'>
                  <div className='classify-res-comp-sec-left'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='10'
                      height='15'
                      viewBox='0 0 10 15'
                      fill='none'
                    >
                      <path
                        d='M0.75 10.0833C0.75 11.5561 1.94391 12.75 3.41667 12.75H6.08333C7.55609 12.75 8.75 11.5561 8.75 10.0833C8.75 8.61057 7.55609 7.41667 6.08333 7.41667H3.41667C1.94391 7.41667 0.75 6.22276 0.75 4.75C0.75 3.27724 1.94391 2.08333 3.41667 2.08333H6.08333C7.55609 2.08333 8.75 3.27724 8.75 4.75M4.75 0.75V14.0833'
                        stroke='var(--text-classify)'
                        strokeWidth='1.5'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                  </div>
                  <div className='classify-res-comp-sec-txt'>
                    Screening Results
                  </div>
                  <div className='classify-res-comp-sec-left'>
                    {!isExpandSecNotes ? (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        onClick={() => setIsExpandSecNotes(!isExpandSecNotes)}
                      >
                        <path
                          d='M10 12L6 8L10 4'
                          stroke='var(--text-classify)'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        fill='none'
                        onClick={() => setIsExpandSecNotes(!isExpandSecNotes)}
                      >
                        <path
                          d='M4 6L8 10L12 6'
                          stroke='var(--text-classify)'
                          strokeWidth='1.5'
                          strokeLinecap='round'
                          strokeLinejoin='round'
                        />
                      </svg>
                    )}
                  </div>
                </div>
                {isExpandSecNotes && renderScreeningResults()}
              </div>
            </>
          )
        )}
      </div>
      {renderTicketModal()}
    </>
  );
};

export default SearchWorkflow;
